import React from "react";
import "./Header.css";
import { Link } from "react-router-dom";

const Header = () => {
    return (
        <>
            <div className="header_container">
                <div className="logo">
                    <img src="images/Logo.png" alt="Loading" className="logo_img" />
                </div>
                <div className="header">
                    <ul>
                        <li><Link to="/">Home</Link></li>
                        <li><Link to="/aboutus">AboutUs</Link></li>
                        <li><Link to="/contactus">ContactUS</Link></li>
                    </ul>
                </div>

                <div>
                    <div className="line1"></div>
                    <div className="line2"></div>
                    <div className="line3"></div>
                </div>
            </div>
        </>
    )
}

export default Header;